<template>
  <b-modal :id="id" size="lg" no-close-on-backdrop>
    <template #modal-header>
      <modal-close-button @confirmed="closeModal" />
      <h4 class="modal-title mx-auto">{{ $t("global.hotelquota") }}</h4>
    </template>

    <div class="row">
      <div class="col-xl-6">
        <div class="form-group">
          <v-select
            v-model="kontingent.gebaeude"
            label="bezeichnung"
            :options="gebaeude"
            :reduce="(g) => g.id"
            :disabled="!editable"
            :placeholder="$t('global.hotel')"
          >
            <span slot="no-options">{{ $t("global.taptosearch") }}</span>
          </v-select>
          <label :class="{ 'text-danger': !kontingent.gebaeude }">{{ $t("global.hotel") }}</label>
        </div>
      </div>
      <div v-if="lehrgang" class="col-xl-6">
        <div class="form-group">
          <v-select
            v-model="kontingent.veranstaltung"
            label="bezeichnung"
            :options="module"
            :reduce="(m) => m.id"
            :disabled="!editable"
            :placeholder="$t('global.allmodules')"
          >
            <span slot="no-options">{{ $t("global.taptosearch") }}</span>
          </v-select>
          <label>{{ $t("global.module") }}</label>
        </div>
      </div>
      <div class="col-xl-6">
        <div class="form-group">
          <v-select
            v-model="kontingent.verrechnungsposition"
            :getOptionLabel="(position) => position.artikel ? position.artikel.bezeichnung : position.id"
            :options="verrechnungspositionen"
            :reduce="(position) => position.id"
            :disabled="!editable"
            :placeholder="$t('global.clearingitempernight')"
          >
            <span slot="no-options">{{ $t("global.taptosearch") }}</span>
          </v-select>
          <label>{{ $t("global.clearingitempernight") }}</label>
        </div>
      </div>
      <div class="col-xl-6">
        <div class="form-group">
          <input
            v-model.number="kontingent.kontingent"
            class="form-control"
            type="number"
            min="0"
            :readonly="!editable"
            placeholder=" "
          />
          <label>{{ $t("global.quota") }}</label>
        </div>
      </div>
    </div>

    <template #modal-footer>
      <button class="btn btn-default mr-2" @click="closeModal">
        {{ $t("global.cancel") }}
      </button>
      <button
        v-if="editable"
        class="btn btn-primary"
        :disabled="!kontingent.gebaeude || saving"
        @click="speichern"
      >
        {{ $t("global.save") }}
      </button>
    </template>
  </b-modal>
</template>

<script>
import Api from "@/api/Api";
import AppApi from "@/api/AppApi";
import ModalCloseButton from "@/components/global/ModalCloseButton";
import { apiErrorToAlert } from "@/utils/Errorhandler";
import { LADE_AUSWAHLWERTE_RESSOURCEN } from "@/store/ressourcen/actions.type";

/**
 * Erfassen/Bearbeiten eines Hotelkontingents (bxc_zimmer).
 * Kurzveranstaltung: veranstaltung gesetzt. Lehrgang: lehrgang gesetzt, Modul optional (leer = alle Module).
 * Öffnen über ref: this.$refs.<ref>.oeffnen(kontingent | null)
 */
export default {
  name: "HotelkontingentModal",
  components: { ModalCloseButton },
  props: {
    id: { type: String, default: "hotelkontingent-modal" },
    veranstaltung: { type: String, required: false },
    lehrgang: { type: String, required: false },
    module: { type: Array, default: () => [] },
    editable: { type: Boolean, required: true },
  },
  data() {
    return {
      kontingentId: null,
      kontingent: this.leeresKontingent(),
      verrechnungspositionen: [],
      saving: false,
    };
  },
  computed: {
    gebaeude() {
      return this.$store.state.ressourcen.gebaeude;
    },
  },
  methods: {
    leeresKontingent() {
      return { gebaeude: null, veranstaltung: null, verrechnungsposition: null, kontingent: null };
    },
    oeffnen(kontingent) {
      if (this.gebaeude.length == 0) this.$store.dispatch(`ressourcen/${LADE_AUSWAHLWERTE_RESSOURCEN}`);
      this.ladeVerrechnungspositionen();

      this.kontingentId = kontingent?.id || null;
      this.kontingent = kontingent
        ? {
            gebaeude: kontingent.gebaeude?.id || null,
            veranstaltung: this.lehrgang ? kontingent.veranstaltung?.id || null : null,
            verrechnungsposition: kontingent.verrechnungsposition?.id || null,
            kontingent: kontingent.kontingent,
          }
        : this.leeresKontingent();

      this.$bvModal.show(this.id);
    },
    ladeVerrechnungspositionen() {
      const params = this.lehrgang ? { lehrgang: this.lehrgang } : { veranstaltung: this.veranstaltung };
      Api.get("/rechnungslegung/verrechnungsposition/", { params }).then((response) => {
        this.verrechnungspositionen = response.data || [];
      });
    },
    speichern() {
      this.saving = true;
      const json = {
        gebaeude: this.kontingent.gebaeude,
        lehrgang: this.lehrgang || null,
        veranstaltung: this.lehrgang ? this.kontingent.veranstaltung : this.veranstaltung,
        verrechnungsposition: this.kontingent.verrechnungsposition,
        kontingent: this.kontingent.kontingent === "" ? null : this.kontingent.kontingent,
      };

      const request = this.kontingentId
        ? AppApi.put("zimmer/", json, { params: { id: this.kontingentId } })
        : AppApi.post("zimmer/", json);

      request
        .then(() => {
          this.$notify({
            type: "success",
            title: this.$t("global.actionsuccessful"),
            text: this.$t("global.hotelquotasavedsuccessfully"),
          });
          this.$emit("saved");
          this.closeModal();
        })
        .catch((e) => {
          this.$notify(apiErrorToAlert(e));
        })
        .finally(() => {
          this.saving = false;
        });
    },
    closeModal() {
      this.$bvModal.hide(this.id);
    },
  },
};
</script>
